
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import DateRange from '@/components/DateRange.vue';
import TimePicker from '@/components/TimePicker.vue';
import moment from 'moment';

@Component({
  components: { DateRange, TimePicker },
})
export default class DateTimePicker extends Vue {
  @Prop({ required: true }) private value!: string | Date;

  @Prop({}) private label!: string;

  @Prop({}) private rules!: any[];

  @Prop({ default: false }) private disabled!: boolean;

  private get m() {
    return this.value ? moment(this.value) : null;
  }

  private get date() {
    return this.m?.format('YYYY-MM-DD');
  }

  private get time() {
    return this.m?.format('HH:mm');
  }

  private get myrules() {
    return this.rules.map((r: (v: string | null) => boolean | string) => (v: string) => r(this.date ? `${this.date} ${this.time}` : null));
  }

  @Emit('input')
  private updateDate(date: string) {
    return date ? `${date} ${this.time || '00:00'}:00` : null;
  }

  @Emit('input')
  private updateTime(time: string) {
    return this.date ? `${this.date} ${time || '00:00'}:00` : null;
  }
}
